import { FileDto } from '@ups/xplat/api/dto';
import { Observable, Subject } from 'rxjs';
import { IDynamicResponseBody } from '../models';

interface AttachmentsByControl {
  [key: string]: Array<FileDto>;
}

/**
 * The file control reads the service's attachments (per form control) and its active response,
 * which loads, uploads, removals, submits and resets rewrite outside any template event. Every
 * write goes through here and emits `changed$`, so an OnPush file control can mark itself
 * (WI 35584).
 */
export class DynamicAttachmentState {
  private readonly changes = new Subject<void>();
  private _attachments: AttachmentsByControl | null = null;
  private _formResponse: IDynamicResponseBody | null = null;

  get changed$(): Observable<void> {
    return this.changes.asObservable();
  }

  get attachments(): AttachmentsByControl | null {
    return this._attachments;
  }

  set attachments(value: AttachmentsByControl | null) {
    this._attachments = value;
    this.changes.next();
  }

  get formResponse(): IDynamicResponseBody | null {
    return this._formResponse;
  }

  set formResponse(value: IDynamicResponseBody | null) {
    this._formResponse = value;
    this.changes.next();
  }

  add(name: string, attachment: FileDto) {
    const attachments = (this._attachments ??= {});
    (attachments[name] ??= []).push(attachment);
    this.changes.next();
  }

  remove(name: string, attachment: FileDto) {
    const list = this._attachments?.[name];
    const index = attachment
      ? (list?.findIndex((a) => a.fileID === attachment.fileID) ?? -1)
      : -1;
    if (index > -1) {
      list?.splice(index, 1);
      this.changes.next();
    }
  }
}
